/**
 * Parses a username into one of two possibilities: with ampersand or without.
 * It does not check for validity.
 *
 * @param username
 * @param ampersand
 */
const parseUsername = (username, { ampersand = false } = {}) => {
  if (!username || !username.length) {
    return '';
  }

  const without = username.replace(/@/g, '');
  return `${ampersand ? '@' : ''}${without}`;
};

module.exports = parseUsername;
